import { TokenWalletActionTypes, TokenWalletState } from "./types";
import { fetchError, fetchRequest, fetchSuccess } from "./actions";
import { createReducer } from "typesafe-actions";
export const initialState: TokenWalletState = {
  loading: false,
  errors: undefined,
  data: []
};
type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>;
export default createReducer<TokenWalletState, ActionType>(initialState)
  .handleType(TokenWalletActionTypes.FETCH, state => ({
    ...state,
    loading: true,
    data: [],
    errors: undefined
  }))
  .handleType(TokenWalletActionTypes.FETCH_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    data: (action.payload.data ? action.payload.data : []),
    errors: undefined
  }))
  .handleType(TokenWalletActionTypes.FETCH_ERROR, (state, action) => ({
    ...state,
    loading: false,
    data: [],
    errors: action.payload
}));